const { fetchJsonApi } = require('./abstract');
/**
 * @return A promise that returns the API's version information
 */
function getVersion(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v2/version',
    expectedStatus: 200,
    description: 'Fetching API version',
  });
}

module.exports = {
  getVersion,
};
